
var sprite = require("D:/a/1/s/Web/CMS/App_Themes/Safestore/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 20 20.001\" id=\"icon-search\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <path d=\"M11.536,8.563c0,1.449-1.179,2.628-2.628,2.628c-1.449,0-2.628-1.179-2.628-2.628\r\n\tc0-1.449,1.179-2.628,2.628-2.628C10.357,5.935,11.536,7.114,11.536,8.563z M20,10c0,5.523-4.477,10.001-10,10.001\r\n\tC4.478,20.001,0,15.523,0,10C0,4.477,4.478,0,10,0C15.523,0,20,4.477,20,10z M16.264,14.099l-2.888-2.888\r\n\tc0.462-0.777,0.733-1.681,0.733-2.649c0-2.868-2.333-5.201-5.201-5.201S3.707,5.695,3.707,8.563c0,2.868,2.333,5.201,5.201,5.201\r\n\tc0.968,0,1.872-0.271,2.648-0.733l2.888,2.889c0.19,0.189,0.498,0.189,0.688,0l1.131-1.132\r\n\tC16.454,14.597,16.454,14.29,16.264,14.099z\"/> </symbol>";
module.exports = sprite.add(image, "icon-search");


/*****************
 ** WEBPACK FOOTER
 ** ./svg/src/search.svg
 ** module id = 215
 ** module chunks = 24
 **/